<template>
    <v-container>
        <loading-spinner v-if="loading"/>
        <div v-else>
            <back-button fixed/>
            <routine-creator hide-use-existing :default-routine="routine"/>
        </div>
    </v-container>
</template>

<script>

import RoutineCreator from "@/components/coach/routines/RoutineCreator";
import {getMergedBlocks} from "@/utils/Exercises";
import {db} from '@/utils/Firebase'
import BackButton from "@/components/common/BackButton";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {
        LoadingSpinner,
        BackButton,
        RoutineCreator
    },
    data() {
        return {
            loading: false,
            routine: null
        }
    },
    async mounted() {
        const vm = this
        await vm.setDefaultRoutine()
    },
    methods: {
        async setDefaultRoutine() {
            const vm = this
            vm.loading = true
            const routineRef = await db.collection('routines').doc(vm.$route.params.uid).get()
            let routine = routineRef.data()
            routine.id = routineRef.id
            routine.blocks = await getMergedBlocks(routine.blocks)
            vm.routine = routine
            vm.loading = false
        }
    }

}

</script>

<style scoped>


</style>